module.exports = __webpack_public_path__ + "static/media/tbint.b6b4125b.jpg";